export const selectManufacturerType = {
    bindings: {},
    template: require('./select-manufacturer-type.html'),
    controller: 'SelectManufacturerTypeController',
};
